import React from "react";
import LoadingIcon from "../../commons/PanelAssets/loading.gif";

const Loading = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="">
        <img src={LoadingIcon} alt="Spinning Tom Nook Loading Icon" width="32" height="32" />
      </div>
    </div>
  );
};

export default Loading;
